













































import { AxiosResponse, FromStore } from "@abaco/web-common/src/app";
import { ToastOptions } from "@abaco/web-common/src/app/Toasted";
import { Validable } from "@abaco/web-components/src/components/form/Validable";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Prop, Ref, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID, LOGIN_CONTEXT } from "../index";
import { AccountURL } from "../models/AccountURLs";
import { ContextFunctions } from "../models/FunctionResponse";

@Component
export default class LoginPage extends Vue {
    @Inject() toast!: (message: string, options?: ToastOptions) => void;
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @FromStore(MODULE_ID) userFunctions!: ContextFunctions | null;
    @Ref("form") private form!: Validable;
    @Prop({ default: "/" }) private redirectTo!: string;
    @Prop({ type: Boolean }) isOuter!: boolean;

    userId = "";
    password = "";
    loading = false;
    errors: TranslateResult[] = [];
    warnings: TranslateResult[] = [];
    createAccountURL: AccountURL | null = null;
    forgotPasswordURL: AccountURL | null = null;

    async mounted() {
        try {
            const urls = (await this.maltaModule.maltaApi.getAccountURLs()).portalconfs;
            this.createAccountURL = urls.find(i => i.name === "create_user_url") || null;
            this.forgotPasswordURL = urls.find(i => i.name === "forgot_password_url") || null;
        } catch (err) {
            this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        }
    }

    usernameRules = [(v: unknown) => !!v || this.i18n("valid.mandatory-field")];
    passwordRules = [(v: unknown) => !!v || this.i18n("valid.mandatory-field")];

    createUser() {
        if (this.createAccountURL?.value) {
           // debugger
            const url = new URL(this.createAccountURL.value);
            url.searchParams.set("locale", navigator.language);
            url.searchParams.set("app", location.href);
            window.location.href = url.toString();
            
           
        }
    }

    forgotPassword() {
        if (this.forgotPasswordURL?.value) {
            const url = new URL(this.forgotPasswordURL.value);
            url.searchParams.set("locale", navigator.language);
            url.searchParams.set("app", location.href);
            window.location.href = url.toString();
        }
    }
    public async doLogin() {
    if (this.loading || !this.form.validate()) {
        return;
    }

    this.errors = [];
    this.warnings = [];

    this.loading = true;
    try {
        const messages = await this.maltaModule.tokensResources.login(this.userId, this.password);
        if (messages.errors.length > 0) {
            this.errors = messages.errors.map(e => this.getErrorMessage(e.key));
            return;
        } else if (messages.warnings.length > 0) {
            this.warnings = messages.warnings.map((w: { key: string; values: string[] }) =>
                this.i18n(w.key.toLowerCase(), w.values)
            );
        }

        /** Check if the user has login functions */
        const hasUserFunction = await this.maltaModule.isFunctionEnabled(LOGIN_CONTEXT, "USER");

        if (!hasUserFunction) {
            this.errors.push(this.i18n("err.context-notlinked"));
            this.maltaModule.tokensResources.logout();
            return;
        }

        const haveContext = await this.maltaModule.checkContext();
        if (!haveContext) {
            console.warn(this.i18n("err.context-notlinked"));
            // this.errors.push(this.i18n("err.context-notlinked"));
            // return;
        }

        if (this.warnings.length) {
            this.warnings.forEach(w => this.toast(w.toString(), { type: "info", duration: 4000 }));
        }

        this.$router.push(this.redirectTo);
    } catch (err) {
        if (err && typeof err === "object") {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const r = (err as any).response as AxiosResponse;
            if (r?.status == 401) {
                if (r.data && r.data.errors) {
                    this.errors = r.data.errors.map((e: { key: string }) => this.getErrorMessage(e.key));
                } else {
                    this.errors = [this.i18n("err.baduserorpwd")];
                }
            } else {
                this.errors = [this.i18n("err.generic")];
            }
        }
    } finally {
        this.loading = false;
    }
}

private getErrorMessage(key: string): string {
    const errorMessages: { [key: string]: string } = {
        "sso2.err.mustChangePasswordAtStart": "Password never changed. Kindly change your password using the Forgot Password option",
    };

    return errorMessages[key] || this.i18n("err.generic").toString();
}


}
